export var VERSION = '2.13.0';
//# sourceMappingURL=version.js.map